module.exports = __webpack_public_path__ + "img/11.4e4a4ee8.svg";